import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-to-the-top-link',
  templateUrl: './to-the-top-link.html',
  styleUrl: './to-the-top-link.scss',
  imports: [TranslatePipe]
})
export class ToTheTopLink {
  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
